const USER_ROLES = {
  teacher: "Teacher",
  principal: "School admin",
  district_admin: "District admin",
  parent: "Caregiver",
  student: "Student",
} as const;

export default USER_ROLES;
